import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BackgroundBox = ({ children, className }) => {
  return <div className={classNames(['background-box__main', className])}>{children}</div>;
};
BackgroundBox.defaultProps = {
  className: '',
};

BackgroundBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

export default BackgroundBox;
